/* Forge 12 PDP: sticky sub-menu, Forge It Out cards (live price + add to cart). */
(function () {
  'use strict';

  /* ---------- Sticky sub-menu ---------- */
  function initSubmenu() {
    var nav = document.querySelector('[data-forge-submenu]');
    if (!nav) return;
    var hero = document.getElementById('overview');
    var header = document.querySelector('sticky-header') || document.querySelector('header');
    var links = Array.prototype.slice.call(nav.querySelectorAll('.forge-submenu__link'));
    // the #buy heading sits mid-column in the buy box; scroll to / track the whole buy-box section instead
    function target(id) {
      var t = document.getElementById(id);
      return t && t.matches('.product-details-area__t') ? t.closest('.shopify-section') : t;
    }
    var targets = links.map(function (a) { return target(a.dataset.anchor); });
    // hide links whose section is not on the page (e.g. Video before the walkthrough ships)
    links.forEach(function (a, i) { if (!targets[i]) a.parentNode.hidden = true; });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function headerBottom() {
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    }
    function update() {
      var top = headerBottom();
      nav.style.top = top + 'px';
      var past = hero ? hero.getBoundingClientRect().bottom <= top : window.scrollY > 400;
      nav.classList.toggle('is-visible', past);
      document.documentElement.style.setProperty('--forge-submenu-h', past ? nav.offsetHeight + 'px' : '0px');
      var line = top + nav.offsetHeight + 40, current = null;
      targets.forEach(function (t, i) {
        if (t && t.getBoundingClientRect().top <= line) current = links[i];
      });
      links.forEach(function (a) {
        var on = a === current;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      var list = nav.firstElementChild;
      if (current && past && list.scrollWidth > list.clientWidth) {
        list.scrollLeft = Math.max(0, current.parentNode.offsetLeft - 24);
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('.forge-submenu__link');
      if (!a) return;
      var t = target(a.dataset.anchor);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - headerBottom() - nav.offsetHeight;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      history.replaceState(null, '', '#' + a.dataset.anchor);
    });
    update();
  }

  /* ---------- In-page links (PADDLE / PEDAL / POWER tiles, hero CTA, etc.) ----------
     Same landing spot as the sub-menu: clear the sticky header + sub-menu, and treat the #buy heading as the whole buy-box section. */
  function initAnchorLinks() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || a.closest('[data-forge-submenu]') || a.hasAttribute('data-toggle') || a.getAttribute('role') === 'tab') return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      var t = id && document.getElementById(id);
      if (!t) return;
      if (t.matches('.product-details-area__t')) t = t.closest('.shopify-section') || t;
      e.preventDefault();
      var header = document.querySelector('sticky-header') || document.querySelector('header');
      var nav = document.querySelector('[data-forge-submenu]');
      var hb = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var y = t.getBoundingClientRect().top + window.scrollY - hb - (nav ? nav.offsetHeight : 0);
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      history.replaceState(null, '', '#' + id);
    });
  }

  /* ---------- Forge It Out cards ---------- */
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function syncCard(card) {
    var handle = card.dataset.handle;
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var v = p.variants.filter(function (x) { return String(x.id) === card.dataset.variantId; })[0] || p.variants[0];
        var price = card.querySelector('[data-forge-price]');
        if (price) price.textContent = money(v.price);
        var btn = card.querySelector('[data-forge-atc]');
        if (btn && !v.available) {
          // not sold online (no stock planned): point to dealers instead of a dead "Sold Out" button
          var a = document.createElement('a');
          a.className = 'btn btn-secondary';
          a.href = '#dealers';
          a.textContent = 'Find a Dealer';
          btn.replaceWith(a);
        }
      })
      .catch(function () { /* keep the server-rendered price/button */ });
  }
  function addToCart(btn) {
    var label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      })
      .catch(function (err) {
        btn.textContent = label;
        btn.disabled = false;
        var msg = btn.closest('.forge-card').querySelector('[data-forge-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      })
      .finally(function () { btn.classList.remove('loading'); });
  }
  function initForgeItOut() {
    var cards = document.querySelectorAll('.forge-card[data-handle]');
    cards.forEach(syncCard);
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-forge-atc]');
      if (btn && !btn.disabled) addToCart(btn);
    });
  }

  function init() { initSubmenu(); initAnchorLinks(); initForgeItOut(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
